'use strict';

var $ = require('js/sw-jquery/sw-jquery');

/**
 * Helper bar that transitions through sections as your scroll through the page.
 * @param $fragment
 */
module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-transition-bar]').each(function() {
    var $el = $(this);

    require(['js/lib/views/TransitionBar'], function(TransitionBar) {
      new TransitionBar({
        el: $el
      });
    });
  });

};
